import { IBasicFile } from '@sdk/contracts';

import {
  DocumentWrapper,
  DocumentsWrapper,
  ExtraDocumentsWrapper
} from './LiveRecordItemDocuments.styles';

import { DocumentDisplay } from '@/components/DocumentDisplay';

export const LiveRecordItemDocuments = ({ attachments }: { attachments: IBasicFile[] }) => {
  const plusMessage = `+${attachments.length - 2}`;
  return (
    <DocumentsWrapper>
      {attachments.slice(0, 2).map(document => (
        <DocumentWrapper key={document._id}>
          <DocumentDisplay file={document} isEditable={false} handleDelete={() => {}} />
        </DocumentWrapper>
      ))}
      {attachments.length > 2 && <ExtraDocumentsWrapper>{plusMessage}</ExtraDocumentsWrapper>}
    </DocumentsWrapper>
  );
};
